import { API_ROUTES_FOR_AXIOS } from '../constants/ApiRoutes';
import { handleError } from '../utils/commonErrorUtils';
import { axiosInstance } from '../constants/axiosInstance';
import { ApiResponse } from '../types/commonResponseTypes';
import {
  AUTH_FOR,
  DashboardSessionStatusResponse,
  LogoutApiResponse,
  ScopesOverviewResponse,
} from '../types/oAuth';
import { AxiosError } from 'axios';

export const getSessionDetails = async (): Promise<
  ApiResponse<DashboardSessionStatusResponse>
> => {
  try {
    const { data } = await axiosInstance.get(
      API_ROUTES_FOR_AXIOS['getSessionDetails'](),
    );

    return data;
  } catch (error: any) {
    return handleError(error);
  }
};

export const userLogout = async (): Promise<ApiResponse<LogoutApiResponse>> => {
  try {
    const { data } = await axiosInstance.post(API_ROUTES_FOR_AXIOS['logout']());

    return data;
  } catch (error: any) {
    return handleError(error);
  }
};

export const getSignUpUrl = async (
  redirect?: string,
): Promise<ApiResponse<string>> => {
  try {
    const { data } = await axiosInstance.get(
      API_ROUTES_FOR_AXIOS['getSignUpUrl'](redirect),
    );

    return data;
  } catch (error: any) {
    return handleError(error);
  }
};

export const getOauthReauthSignUpUrl = async (
  intentToken: string,
): Promise<ApiResponse<string>> => {
  try {
    const { data } = await axiosInstance.get(
      API_ROUTES_FOR_AXIOS['getOauthReauthSignUpUrl'](intentToken),
    );

    return data;
  } catch (error: any) {
    return handleError(error);
  }
};

export const getAuthUrlForAdditionalScopes = async (
  scopes: string[],
  redirect?: string,
): Promise<ApiResponse<string>> => {
  try {
    const payload = {
      authFor: AUTH_FOR.FRONT_END,
      scopes,
      ...(redirect ? { redirect } : {}),
    };
    const { data } = await axiosInstance.post(
      API_ROUTES_FOR_AXIOS['getAuthUrlForAdditionalScopes'](),
      payload,
    );

    return data;
  } catch (error: any) {
    return handleError(error);
  }
};

export const getOauthScopesOverview = async (): Promise<
  ApiResponse<ScopesOverviewResponse>
> => {
  try {
    const { data } = await axiosInstance.get(
      API_ROUTES_FOR_AXIOS['getOauthScopesOverview'](),
    );

    return data;
  } catch (error: any) {
    return handleError(error);
  }
};

export const getScopesSignInUrl = async (
  scopes: string[],
  redirect?: string,
): Promise<ApiResponse<string>> => {
  try {
    const payload = {
      authFor: AUTH_FOR.FRONT_END,
      scopes,
      // Settings submits the complete desired optional-scope set. Explicit
      // replacement is required when one capability is added while another is
      // removed in the same update; the server always restores core scopes.
      replaceScopes: true,
      ...(redirect ? { redirect } : {}),
    };

    const { data } = await axiosInstance.post(
      API_ROUTES_FOR_AXIOS['getOauthScopesSignInUrl'](),
      payload,
    );

    return data;
  } catch (error: any) {
    return handleError(error);
  }
};

export const getAccessToken = async (): Promise<
  ApiResponse<{ accessToken: string; pickerAppId: string }>
> => {
  try {
    // Call the hosturl/oauth/tokens endpoint
    const { data } = await axiosInstance.get('oauth/tokens');

    // Validate that 'data' is structured as expected.
    if (!data || typeof data !== 'object' || !data.success) {
      return { success: false, message: 'Invalid response from server' };
    }

    return data;
  } catch (error: unknown) {
    return handleError(error as AxiosError);
  }
};
